import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { ENDPOINTS } from 'config/endpoints';
import { isLocal } from 'utils/uiHelpers';
import { getCsrfToken, refreshCsrfToken } from 'utils/clients/csrf';

interface RetriableConfig {
  url?: string;
  headers?: Record<string, string>;
  __csrfRetried?: boolean;
}

export interface CsrfRetryError {
  config?: RetriableConfig;
  response?: { data?: unknown };
}

export const isCsrfError = (error: CsrfRetryError): boolean => {
  const body = error?.response?.data;
  return typeof body === 'string' && body.toLowerCase().includes('csrf');
};

export const shouldRetryCsrf = (error: CsrfRetryError): boolean => {
  const config = error?.config;
  return (
    isCsrfError(error) &&
    !!config &&
    !config.__csrfRetried &&
    !config.url?.includes(ENDPOINTS.csrf.main)
  );
};

export const retryWithFreshCsrf = async (
  error: CsrfRetryError,
): Promise<AxiosResponse> => {
  const config = error.config as RetriableConfig;
  config.__csrfRetried = true;

  const refreshed = await refreshCsrfToken();
  const csrfToken = getCsrfToken();
  if (!refreshed || !csrfToken) {
    return Promise.reject(error);
  }

  config.headers = {
    ...config.headers,
    ...(isLocal()
      ? { 'X-CSRF-TOKEN-LOCAL': csrfToken }
      : { 'X-CSRF-TOKEN': csrfToken }),
  };
  return axios(config as AxiosRequestConfig);
};
